<h3>{{ menuHeaderText }}</h3>
<app-sub-menu [menuItems]="menuItems"></app-sub-menu>
<div class="grid-container">
  <router-outlet></router-outlet>
</div>